import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarItemInt } from '@app/interfaces/calendar.interface';
import moment from 'moment';
/**
 * Componente que representa un elemento del calendario.
 */
@Component({
    selector: 'am-calendar-item',
    templateUrl: './am-calendar-item.component.html',
    styleUrls: ['./am-calendar-item.component.scss'],
    standalone: false
})
export class AmCalendarItemComponent implements OnInit {

 
  /**
   * Objeto que representa un elemento del calendario.
   * Este objeto contiene la información del día que se mostrará en el componente.
   *
   * @type {CalendarItemInt}
   */
  @Input('calendar') objCalendar: CalendarItemInt;

  /**
   * Fecha actual que se utiliza para comparar y resaltar el día actual en el calendario.
   *
   * @type {Date}
   */
  @Input() currentDate: Date;

  /**
   * EventEmitter que se utiliza para emitir un evento cuando el elemento del calendario es seleccionado.
   * El evento emite el objeto `objCalendar` con la propiedad `selected` actualizada.
   *
   * @type {EventEmitter<any>}
   */
  @Output() selected: EventEmitter<any> = new EventEmitter();

  /**
   * Variable que almacena la fecha actual en formato `moment`.
   * Se utiliza para facilitar la manipulación y comparación de fechas.
   *
   * @type {any}
   */
  currentDay: any;

  constructor() { }

  ngOnInit() {
    this.currentDay = moment(this.currentDate);
  }
  /**
   * Método que se ejecuta cuando el usuario selecciona el elemento del calendario.
   * Actualiza la propiedad `selected` del objeto `objCalendar` y emite un evento
   * con el objeto actualizado.
   *
   * @param {any} e - Evento que desencadena la selección (por ejemplo, un clic).
   * @return {void} No retorna ningún valor.
   */
  onSelect(e) {
    this.objCalendar.selected = true;
    this.selected.emit(this.objCalendar);
  }

}
